import React from 'react'
import { GeneralStyles, ButtonStyles, HomeStyles, StudentsStyles, GeneralAssessmentStyles, AssessmentStyles, ReportStyles, GeneralReportStyles } from './Style'
import { Header, tutorialsHooks } from '.'
import { Divider, IconButton, SvgIcon } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { ReactComponent as UploadFileIcon } from 'assets/icons/UploadFile.svg';
import { Wave } from 'assets'
import { Img } from 'styles/GlobalStyle';
import { thirdly4 } from 'styles/theme';
import { Edit } from '@mui/icons-material';

const General = () => {
    const navigate = useNavigate()
    const homeItems = tutorialsHooks.useHomeItems()
    const generalItems = tutorialsHooks.useGeneralItems()

    const title = "הכרות כללית עם המערכת"
    const subTitle = "ככה זה עובד"

    return (
        <GeneralStyles>
            <Header title={title} subTitle={subTitle} />
            <div className='title'>{"תפריט ראשי מימין"}</div>
            <div className='content general-content'>
                {generalItems.map((item) => {
                    const { to, title, button } = item
                    const { label, icon } = button

                    return (
                        <div className='general-item'>
                            <div className='item-button'>
                                <ButtonStyles variant='contained' color="dark">
                                    <SvgIcon sx={{ fontSize: 14 }} component={icon} inheritViewBox />
                                    {label}
                                </ButtonStyles>
                            </div>
                            <div className='item-card'>
                                <div className='item-card-header'>
                                    {title}
                                    <IconButton onClick={() => navigate(to)}>
                                        <SvgIcon component={GoIcon} inheritViewBox />
                                    </IconButton>
                                </div>
                                {item.type == "home" &&
                                    <div className='item-card-content'>
                                        <HomeStyles>
                                            {homeItems.map((item) => {
                                                const { label, icon, description } = item

                                                return (
                                                    <div className='home-item'>
                                                        <div className='home-card'>
                                                            <SvgIcon component={icon} inheritViewBox />
                                                            {label}
                                                        </div>
                                                        <div className='home-description'>
                                                            {description}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </HomeStyles>
                                    </div>
                                }
                                {item.type == "students" &&
                                    <div className='item-card-content'>
                                        <StudentsStyles>
                                            {[...Array(3)].map((row) =>
                                                <React.Fragment>
                                                    <div className='table-row'>
                                                        <div className='table-col blurred'>12</div>
                                                        <div className='table-col blurred'>שירה לוין</div>
                                                        <div className='table-col blurred'>כיתה ג</div>
                                                        <div className='table-col blurred'> ג</div>
                                                        <div className='table-col blurred'> 1</div>
                                                        <div className='table-col'><Edit fontSize='small' /></div>
                                                    </div>
                                                    <Divider sx={{ borderColor: thirdly4 }} />
                                                </React.Fragment>
                                            )}
                                        </StudentsStyles>
                                    </div>
                                }
                                {item.type == "assessments" &&
                                    <div className='item-card-content preform-assessment-table'>
                                        <GeneralAssessmentStyles>
                                            <div className='table-row'>
                                                <div className='table-col blurred'>123</div>
                                                <div className='table-col blurred'>שירה לוין</div>
                                                <div className='table-col blurred'>שיום אותיות</div>
                                                <div className='table-col assessment-status'>לא בוצע</div>
                                                <div className='table-col blurred'>שיום אותיות</div>
                                                <div className='assessment-arrows'>
                                                    <div className='row-action'>
                                                        <SvgIcon component={GoIcon} inheritViewBox />
                                                    </div>
                                                    <div className='wrap-tooltip'>
                                                        <div className='tooltip go-tooltip'>
                                                            {"מעבר לביצוע המבדק בתוך המערכת"}
                                                        </div>
                                                    </div>
                                                    <div className='row-action'>
                                                        <SvgIcon component={UploadFileIcon} inheritViewBox />
                                                    </div>
                                                    <div className='wrap-tooltip'>
                                                        <div className='tooltip upload-tooltip'>
                                                            {"העלאת מבדק שבוצע מחוץ למערכת"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </GeneralAssessmentStyles>
                                    </div>
                                }
                                {item.type == "reports" &&
                                    <div className='item-card-content'>
                                        <GeneralReportStyles>
                                            <div className='wrap-assessment-graph'>
                                                <div className='assessment-graph'>
                                                    {[...Array(3)].map(() => <Divider sx={{ borderColor: "#E2E3E3" }} />)}
                                                </div>
                                                <div className='wrap-wave'>
                                                    <div className='wave'>
                                                        <Img src={Wave} />
                                                    </div>
                                                </div>
                                            </div>
                                        </GeneralReportStyles>
                                    </div>
                                }
                            </div>
                        </div>
                    )

                })}
            </div>
        </GeneralStyles>
    )
}

export default General